// src/locales/si.js
import { auth } from './si/auth';
import { business } from './si/business';
import { common } from './si/common';
import { dashboard } from './si/dashboard';
import { errors } from './si/errors';
import { footer } from './si/footer';
import { forms } from './si/forms';
import { header } from './si/header';
import { language } from './si/language';
import { nav } from './si/nav';
import { orders } from './si/orders';
import { ecomOrders } from './si/ecomOrders';
import { orderAssignment } from './si/orderAssignment';
import { products } from './si/products';
import { productTags } from './si/productTags';
import { attributes } from './si/attributes';
import { categories } from './si/categories';
import { brands } from './si/brands';
import { shops } from './si/shops';
import { sidebar } from './si/sidebar';
import { userRoles } from './si/userRoles';
import { users } from './si/users';
import { warehouses } from './si/warehouses';
import { couriers } from './si/couriers';
import { packingBatch, courierUpload, dispatch, print } from './si/packingBatch';
import { returnBatch } from './si/returnBatch';
import { courierInvoice } from './si/courierInvoice';
import { purchaseOrder } from './si/purchaseOrder';
import { stockAdjustment } from './si/stockAdjustment';
import { stockTransfer } from './si/stockTransfer';
import { report } from './si/report';
import { supplier } from './si/supplier';
import { phoneBlacklist } from './si/phoneBlacklist';
import { dropshipping } from './en/dropshipping';
import { profile } from './en/profile';
import { pos } from './si/pos';
import { expenses } from './si/expenses';
import { leadAutomation } from './si/leadAutomation';
import { messageCenterShifts } from './si/messageCenterShifts';
import { messageCenterShiftTypes } from './si/messageCenterShiftTypes';
import { messageCenterCommission } from './si/messageCenterCommission';
import { messageCenterShiftLeaderCommission } from './si/messageCenterShiftLeaderCommission';
import { paymentVerification } from './si/paymentVerification';
import { callCenterShifts } from './si/callCenterShifts';
import { callCenterCommission } from './si/callCenterCommission';
import { storePickup } from './si/storePickup';
import { creditNote } from './si/creditNote';
import { quotation } from './si/quotation';
import { deliveryNote } from './si/deliveryNote';
import { returnNote } from './si/returnNote';
import { goodsReceivedNote } from './si/goodsReceivedNote';
import { returnToVendor } from './si/returnToVendor';
import { debitNote } from './si/debitNote';
import { procurement } from './si/procurement';
// No si translation yet (parity gap, see AGENTS.md) — alias to en until authored.
import { offlineSales } from './si/offlineSales';

export default {
  common: common,
  nav: nav,
  auth: auth,
  dashboard: dashboard,
  header: header,
  sidebar: sidebar,
  userRoles: userRoles,
  users: users,
  shops: shops,
  warehouses: warehouses,
  orders: orders,
  ecomOrders: ecomOrders,
  orderAssignment: orderAssignment,
  products: products,
  productTags: productTags,
  attributes: attributes,
  categories: categories,
  brands: brands,
  forms: forms,
  errors: errors,
  footer: footer,
  language: language,
  business: business,
  returnBatch: returnBatch,
  courierInvoice: courierInvoice,
  couriers: couriers,
  packingBatch: packingBatch,
  dispatch:dispatch,
  print:print,
  courierUpload: courierUpload,
  purchaseOrder: purchaseOrder,
  stockAdjustment: stockAdjustment,
  stockTransfer: stockTransfer,
  report:report,
  supplier:supplier,
  phoneBlacklist:phoneBlacklist,
  dropshipping: dropshipping,
  pos: pos,
  expenses: expenses,
  profile: profile,
  leadAutomation: leadAutomation,
  messageCenterShifts: messageCenterShifts,
  messageCenterShiftTypes: messageCenterShiftTypes,
  messageCenterCommission: messageCenterCommission,
  messageCenterShiftLeaderCommission: messageCenterShiftLeaderCommission,
  callCenterShifts: callCenterShifts,
  callCenterCommission: callCenterCommission,
  paymentVerification: paymentVerification,
  callCenterShifts: callCenterShifts,
  callCenterCommission: callCenterCommission,
  storePickup: storePickup,
  offlineSales: offlineSales,
  creditNote: creditNote,
  quotation: quotation,
  deliveryNote: deliveryNote,
  returnNote: returnNote,
  goodsReceivedNote: goodsReceivedNote,
  returnToVendor: returnToVendor,
  debitNote: debitNote,
  procurement: procurement,
};